import padZero from './padZero';

export default function formatISODate(isoDate: string): string {
  const date = new Date(isoDate.slice(0, 10) + 'T00:00:00.000');
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();
  return `${padZero(month + 1)}/${padZero(day)}/${year}`;
}
